<script>
  import { User, Doc, Collection } from "sveltefire";
  import Welcome from "./Welcome.svelte";
  import Issue from "./Issue.svelte";
  import { fade } from 'svelte/transition';
  import { listId, sectionId, newsletterId, isDisplayIssue } from './stores.js';
  const displayAside = function(){
    // alert('this works @displayAside');
    isDisplayIssue.set(false)
  }

  console.log("@Content.svelte")
</script>

<!-- <h1>Content Component</h1> -->

  <div>
    <div class="overlay" on:click="{displayAside}">&lt;-</div>

      <User let:user let:auth>
        <div class="signed-in">
          <!-- <h2>Content Signed In</h2> -->
            <!-- <p>Thank you for creating an account.</p> -->

            <!-- <p>(This space intentionally left blank for a future feature.)</p> -->
        </div>

        <div slot="signed-out" class="signed-out">
          <!-- <h2>Content Signed Out</h2> 
            <p>Welcome @Content Signed Out</p> -->
            <!-- <Welcome></Welcome>       -->
        </div>
      </User>

      <Issue newsletterId="{$newsletterId}"></Issue>
  

  </div>

<style>
  /* h1 {color: greenyellow;} */
  h2 {color: limegreen;}

  .overlay { top: 10px; left: 10px; position: relative; width: 20px;
    padding: 0.5rem; display: none; color: black; background-color: cornsilk;
    border-radius: 20px; border: 1px solid gainsboro; font-weight: 900; z-index: 5
  }


  .displaynone {display:inline}
  @media (max-width: 800px) {
    /* .issue {display: none;} */
    .displaynone {display:none}
    .overlay {display:  inline;}
  }
</style>